/* eslint-disable react/prop-types */
import React from "react"

const LayoutLogin = ({ children, className }) => {
  return (
    <>
      <div className={` min-h-screen ${className} bg-light-gray-400`}>
        {children}
      </div>
    </>
  );
};

export default LayoutLogin;
